import React from "react";
import {
  getstartedtodaytetxt,
  buttonDataAppleStore,
  buttonDataPlayStore,
  buttonWebStore,
  handalClickgoogleplay,
  handalClickAppleStore,
  handalClickWebStore,
} from "../../Constants";
import Avatar from "@mui/material/Avatar";
import { Box, Button, Container, Grid } from "@mui/material";
import manimage from "../../../images/Layer07651.webp";
import lineImage from "../../../images/Line 3.png";
import styles from "./AboutUs.module.css";
import Mainstyle from "../../../style.module.css";
import styles2 from "../../../components/Header/LoginForm.module.css";


const Getstarted = () => {
  const { button } = buttonDataPlayStore;
  const { buttons } = buttonDataAppleStore;
  const { buttonWeb } = buttonWebStore;

  return (
    <section className={styles.getstartedwrap}>
        <Container maxWidth="xl">
          <div  style={{ padding: "0 28px" }}>
      <Grid container alignItems="center" className={styles.getContainer} >
        <Grid item xs={12} md={5} lg={5} className={styles.getstartedimgwrap}>
          <img
            src={manimage}
            alt="Get Started"
            className={styles.getstartedimg}
          />
        </Grid>
        <Grid item xs={12} md={7} lg={7} className={styles.buttonGridContainer}>
          <img src={lineImage} className={styles.lineImage} alt="Desi Hisab" />
          <span className={styles.incomeTitleexpenses}>Begin Right Away</span>
          {getstartedtodaytetxt.map((data) => (
            <div key={data.id} className={styles.Getstartedrightcol}>
              <div className={Mainstyle.icontextwrap}>
                <span className={styles.title}>{data.heading}</span>
                <span className={styles.getstartedtext}>
                  {data.description}
                </span>
              </div>

              <Grid container className={styles2.getStartedButtonGrid}>
                <Grid className={styles.btngrid}>
                  <Button
                    sx={button.styles}
                    startIcon={
                      <Avatar
                        className={styles2[button.startIcon.className]}
                        src={button.startIcon.src}
                      />
                    }
                    onClick={handalClickgoogleplay}
                    className={styles2[button.className]}
                  >
                    <div className={styles2[button.content.wrapClassName]}>
                      {button.content.text.map((textItem, index) => (
                        <span key={index} style={textItem.style}>
                          <span className={styles2.getitgooleplay}>
                            {textItem.content}
                          </span>
                        </span>
                      ))}
                    </div>
                  </Button>
                  <Button
                    sx={buttons.styles}
                    startIcon={
                      <Avatar
                        className={styles2[buttons.startIcon.className]}
                        src={buttons.startIcon.src}
                      />
                    }
                    onClick={handalClickAppleStore}
                    className={styles2[buttons.className]}
                  >
                    <div className={styles2[buttons.content.wrapClassName]}>
                      {buttons.content.text.map((textItem, index) => (
                        <span key={index} style={textItem.style}>
                          <span className={styles2.getitgooleplay}>
                            {textItem.content}
                          </span>
                        </span>
                      ))}
                    </div>
                  </Button>
                  <Button
                    sx={buttonWeb.styles}
                    startIcon={
                      <Box
                        component="img"
                        src={buttonWeb.startIcon.src}
                        alt="icon"
                      />
                    }
                    onClick={handalClickWebStore}
                    className={styles2[buttonWeb.className]}
                  >
                    <div className={styles2[buttonWeb.content.wrapClassName]}>
                      {buttonWeb.content.text.map((textItem, index) => (
                        <span key={index} style={textItem.style}>
                          <span className={styles2.getitgooleplay}>
                            {textItem.content}
                          </span>
                        </span>
                      ))}
                    </div>
                  </Button>
                </Grid>
              </Grid>
            </div>
          ))}
        </Grid>
      </Grid>
            </div>        
        </Container>
    </section>
  );
};

export default Getstarted;
